const normalizeScope = (scope) =>
  String(scope || 'checkout')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '') || 'checkout';

/**
 * Create one opaque identifier per customer submit. Callers must create it
 * once, then reuse it for every request that belongs to that submit.
 */
export const createCheckoutAttemptId = (scope = 'checkout') => {
  const uuid = typeof window !== 'undefined' ? window.crypto?.randomUUID?.() : null;
  const entropy = uuid || Math.random().toString(36).slice(2, 14);
  return `${normalizeScope(scope)}_${Date.now().toString(36)}_${entropy}`;
};
